// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__xvcPw","logo-box":"footer_logo-box__n6m63"};